"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportStatus = exports.ExportType = void 0;
var ExportType;
(function (ExportType) {
    ExportType["ExportTokens"] = "EXPORT_TOKENS";
})(ExportType || (exports.ExportType = ExportType = {}));
var ExportStatus;
(function (ExportStatus) {
    ExportStatus["Pending"] = "PENDING";
    ExportStatus["Ready"] = "READY";
    ExportStatus["Failed"] = "FAILED";
})(ExportStatus || (exports.ExportStatus = ExportStatus = {}));
